import { ISelectType } from "@4uhub/lib4uhub";

import {
  IScheduleNewCheckIn,
  IScheduleNewCheckInChild,
  INewScheduleNewCheckIn,
} from "../../../../../../../models/schedule-new-check-in";
import {
  normalizeCoordinate,
  THEN_SELECT_FIELDS,
  TScheduleNewCheckInForm,
  TThenSelectField,
} from "./ScheduleNewCheckInSchema";

const toChild = ({ id, name }: ISelectType): IScheduleNewCheckInChild => ({
  externalId: id,
  externalName: name,
});

const toOption = ({
  externalId,
  externalName,
}: IScheduleNewCheckInChild): ISelectType => ({
  id: externalId,
  name: externalName,
});

// Formulário (seleções {id, name}) -> contrato do backend (ExternalId / ExternalName separados)
export const formToRequest = (
  form: TScheduleNewCheckInForm,
): INewScheduleNewCheckIn => {
  const thenFields = THEN_SELECT_FIELDS.reduce(
    (acc, field) => ({
      ...acc,
      [`${field}ExternalId`]: form[field].id,
      [`${field}ExternalName`]: form[field].name,
    }),
    {} as Record<string, string>,
  );

  return {
    id: form.id,
    tasyScheduleTypeCode: form.tasyScheduleType.id,
    time: Number(form.time),
    metersApproximation: Number(form.metersApproximation),
    latitude: normalizeCoordinate(form.latitude),
    longitude: normalizeCoordinate(form.longitude),
    basicUnitExternalId: form.basicUnitExternalId,
    basicUnitExternalName: form.basicUnitExternalName,
    complUnitExternalId: form.complUnitExternalId,
    complUnitExternalName: form.complUnitExternalName,
    ...thenFields,
    calendars: form.calendars.map(toChild),
    insuranceTypes: form.insuranceTypes.map(toChild),
    insurances: form.insurances.map(toChild),
  } as INewScheduleNewCheckIn;
};

// Contrato do backend -> formulário
export const responseToForm = (
  data: IScheduleNewCheckIn,
  scheduleTypeName: (code: string) => string,
): TScheduleNewCheckInForm => {
  const thenFields = THEN_SELECT_FIELDS.reduce(
    (acc, field) => ({
      ...acc,
      [field]: {
        id: (data as any)[`${field}ExternalId`],
        name: (data as any)[`${field}ExternalName`],
      },
    }),
    {} as Record<TThenSelectField, ISelectType>,
  );

  return {
    ...(data as any),
    ...thenFields,
    tasyScheduleType: {
      id: data.tasyScheduleTypeCode,
      name: scheduleTypeName(data.tasyScheduleTypeCode),
    },
    time: data.time.toString(),
    metersApproximation: data.metersApproximation.toString(),
    calendars: (data.calendars ?? []).map(toOption),
    insuranceTypes: (data.insuranceTypes ?? []).map(toOption),
    insurances: (data.insurances ?? []).map(toOption),
  };
};
